import { createSlice } from "@reduxjs/toolkit";
import { getAllOrderTrackings, getDateFilterTrackingOrders, getInTransitOrders } from "../../api/order/order-tracking";

const initialState = {
  isLoading: false,
  isSuccess: false,
  orderTrackingInfo: [],
};

export const orderTrackingSlice = createSlice({
  name: "orderTracking",
  initialState,
  reducers: {},
  extraReducers: {
    [getInTransitOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getInTransitOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.orderTrackingInfo = payload;
    },
    [getInTransitOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [getAllOrderTrackings.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllOrderTrackings.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.orderTrackingInfo = payload;
    },
    [getAllOrderTrackings.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
    [getDateFilterTrackingOrders.pending]: (state) => {
      state.isLoading = true;
    },
    [getDateFilterTrackingOrders.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.orderTrackingInfo = payload;
    },
    [getDateFilterTrackingOrders.rejected]: (state, { payload }) => {
      state.isLoading = false;
    },
  },
});
// export const { getFulfillmentOrders, getNewVariants } = orderTrackingSlice.actions;
export const orderTrackingSelector = (state) => state.orderTracking;
export default orderTrackingSlice.reducer;
